import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { ReactComponent as FilterIcon } from '@doveconviene/sf-ui/icons/filter.svg'
import Icon from '../../../ui/Icon'

const StyledFilterIcon = styled.div(({ theme: { colors } }) => ({
  width: '24px',
  height: '24px',
  color: colors.primary,
  cursor: 'pointer',
  userSelect: 'none',
}))

const StyledFilterButton = styled.button(() => ({
  background: 'white',
  display: 'flex',
  alignItems: 'center',
  margin: '0px',
  padding: '0px',
  border: '0px',
}))

const StyledFilterTitle = styled.span(({ theme: { colors, breakpoints } }) => ({
  color: colors.primary,
  fontSize: '14px',
  paddingRight: '8px',
  fontWeight: '600',
  [`@media (max-width: ${breakpoints.small})`]: {
    display: 'none',
  },
}))

const FilterIconButton = ({ label, onClick }) => (
  <StyledFilterButton onClick={onClick} data-test="FilterIconButton">
    <StyledFilterTitle>{label}</StyledFilterTitle>
    <StyledFilterIcon>
      <Icon>
        <FilterIcon />
      </Icon>
    </StyledFilterIcon>
  </StyledFilterButton>
)

FilterIconButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
}

FilterIconButton.defaultProps = {
  onClick: () => false,
  label: '',
}

FilterIconButton.displayName = 'FilterIconButton'
FilterIconButton.whyDidYouRender = true

export default React.memo(FilterIconButton)
